// @flow
import React, { Component } from "react";
import classNames from "classnames";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { DrawerStylesClassesType } from "../../../global/styles/generalStyles";
import type { PersonType } from "../../types/PersonTypes";
import { drawerStyles, padImg } from "../../../global/styles/generalStyles";
import { SingleCheckBox } from "imagus-components";
import PersonImage from "../../../../images/person_place.svg";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...drawerStyles(theme),
  padImg
});

type PeopleItemClassesType = {
  ...DrawerStylesClassesType,
  padImg: DictionaryType
};

type PeopleItemPropsType = {
  classes: PeopleItemClassesType,
  person: PersonType,
  open: boolean,
  selectedId: string,
  isChecked?: boolean,
  selectPerson: Function,
  handleToggle: Function
};

class PeopleItem extends Component<PeopleItemPropsType, *> {
  render(): * {
    const { classes, person, open, selectedId, isChecked } = this.props;

    return (
      <ListItem
        button
        onClick={this.props.selectPerson(person.uid)}
        className={classNames(
          classes.item,
          !open && classes.itemHidden,
          selectedId === person.uid && classes.itemSelected
        )}
      >
        <Avatar
          alt={person.face}
          className={classes.padImg}
          src={person.face ? person.face : PersonImage}
        />
        <ListItemText
          primary={person.name}
          disableTypography
          className={classNames(
            classes.itemTitle,
            selectedId === person.uid && classes.itemTitleSelected
          )}
        />
        <SingleCheckBox
          name="peopleItem"
          value={isChecked}
          onChange={this.props.handleToggle(person.uid)}
        />
      </ListItem>
    );
  }
}

export default withStyles(styles)(PeopleItem);
